// src/config/api.js

// Determinar el entorno actual
const isProduction = process.env.NODE_ENV === 'production';

// Configurar la URL base según el entorno
const baseURL = isProduction 
  ? "https://multiserviciosgmm.com/api"
  : "http://localhost:5167";

export default {
  baseURL,
  isProduction
};